import { render, staticRenderFns } from "./VisitCard.vue?vue&type=template&id=493e8a5f"
import script from "./VisitCard.vue?vue&type=script&lang=js"
export * from "./VisitCard.vue?vue&type=script&lang=js"
import style0 from "./VisitCard.vue?vue&type=style&index=0&id=493e8a5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports